import { BitField } from 'src/structures/BitField.js';

export const CalculateDueDateBits = {
  SKIP_WEEKEND: Math.trunc(1),
  SKIP_NATIONAL_HOLIDAY: 1 << 1,
} as const;

export class CalculateDueDateBitField extends BitField(CalculateDueDateBits) {}
